(function () {
    'use strict';

    angular
        .module('oddCampaignModule')
        .directive('oddCampaignQuestionnaire', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.addQuestionnaire = '&?';
        directiveScope.editQuestionnaireList = '&?';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller', '$state',
                function ($rootScope, $scope, $controller, $state) {

                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/odd/campaign/oddCampaignQuestionnaire.[Template].tpl.html';
                    $controller('BoxTmplController', { $scope: $scope });

                    // Page not accessible while campaign is in a read-only state
                    if ($state.is('odd.externalPartyEdit.campaign.editQuestionnaireList') && !$scope.boxContext.campaign._isEditable) {
                        $state.go('^');
                    }
                }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();